// BookingTable.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentPage } from '../../../../../Redux/slice/features/paginationSilce';
import DataTable from '../../../../../Common/DataTable/DataTable';
import DataTableHeader from '../../../../../Common/DataTableHeader/DataTableHeader';
import DataTableFooter from '../../../../../Common/DataTableFooter/DataTableFooter';
import { fetchUnitOcc } from '../../../../../Redux/slice/features/reportSlice';
import { unitwiseColumns } from './UnitWiseOccData';
import { useNavigate } from 'react-router-dom';
import { fetchUserDetails, rehydrateAuthState } from '../../../../../Redux/slice/features/authSlice';

const BookingTable = () => {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.report);
  const currentPage = useSelector((state) => state.pagination.currentPage);
  const itemsPerPage = useSelector((state) => state.pagination.itemsPerPage);
  const { isAuthenticated, user, loading } = useSelector((state) => state.auth);
  
  const [dataT, setDataT] = useState([]);
  const navigate = useNavigate();


   useEffect(() => {
    if (isAuthenticated && user?.user?.PropertyID!==null) {
     
      dispatch(fetchUnitOcc(user.user.PropertyID));
    } else if (isAuthenticated && user?.user?.PropertyID=== null) {
      
      dispatch(fetchUnitOcc());
      
    }
    
  }, []);
  

  useEffect(() => {
      dispatch(rehydrateAuthState());
      dispatch(fetchUserDetails());
    }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded") {
      const fetchedData = data.map((history) => ({
        hotelName: history.PropertyName,
        noBooking: history.NoofBooking,
        actions: (
          <button
            type="button"
            className="btn"
            onClick={() => handleViewHotel(history.PropertyID)}
          >
            <i className="bi bi-eye"></i>
          </button>
        ),
      }));
      setDataT(fetchedData);
    }
  }, [data, status]);

  useEffect(() => {
    dispatch(setCurrentPage(1));
  }, [itemsPerPage, dispatch]);

  const handleViewHotel = (hotelId) => {
    //const viewUrl = `/booking-view/${hotelId}`;
    navigate(`/unitwise-occ/${hotelId}`);
  };

  
  const totalPages = Math.ceil(dataT.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dataT.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      dispatch(setCurrentPage(p => p + 1));
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      dispatch(setCurrentPage(p => p - 1));
    }
  };

  return (
    <>
      {status === "loading" && <h4>Loading...</h4>}
      {status === "failed" && <p>Error: {error}</p>}
      {status === "succeeded" && (
        <>
          <DataTableHeader columns={unitwiseColumns} data={dataT} />
          <DataTable
            columns={unitwiseColumns}
            data={currentItems}
            enablePagination={false}
          />
          <DataTableFooter
            dataT={dataT}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
          />
        </>
      )}
    </>
  );
};

export default BookingTable;
